import React, { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
} from "../../../components/common/basic";
import CountdownTimer from "./components/CountdownTimer";
import { BackButton, FeatureHeader } from "../../../components/common";
import useMashupNWinHome from "./hooks/useMashupnWinHome";

const now = new Date().getTime();
const MashupnWinHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MashupAndWinHome",
        firebase_screen_class: "MashupAndWinHome",
      })
    );
  }, []);

  const { background, history, bannerImage, tailImage, tips, note } =
    useMashupNWinHome();
  const mashupLink = "https://mymtn.mtn.com.gh/cB5t/hi5wvc9t?page=mashup";

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />
          <FeatureHeader
            image={bannerImage}
            buttonText="My Points"
            title={["Mashup & Win", "Promo"]}
            onClick={() => history.push("mashupnwin/points")}
            background={background}
            secondaryBackground={"#fff"}
          >
            <CountdownTimer
              timeRemaining={30000}
              startTime={now}
              background={background}
            />
          </FeatureHeader>

          <Body>
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNRegularItalic", margin: "0 0 24px 0" }}
              >
                <Span style={{ fontFamily: "MTNBoldItalic" }}>{`Yo`}</Span>
                {" Peeps!"}
              </StyledText>

              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNRegular" }}
                size={13}
              >
                MTN Pulse presents another juicy offer in the month of love and
                sharing. Just continue mashing-up on the Pulse App, earn points
                and redeem your points at the end of the promo. You get to win
                amazing prizes with our partners;
              </StyledText>

              <StyledText
                letterSpacing={-0.38}
                height={17}
                style={{ fontFamily: "MTNRegular" }}
                size={13}
              >
                Effective November 1, 2022 all mashup performed on the Pulse App
                will be awarded points which is redeemable on the last day of
                the promo November 30, 2022. Build at least 2,000 points by the
                end of the promo and redeem vouchers from KFC, Melcom, Potbelly
                Shack and Shoprite.
              </StyledText>

              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "32px",
                  alignItems: "center",
                  marginInline: 15,
                }}
                color={background}
                onClick={() => {
                  window.open(mashupLink, "mashup");
                }}
              >
                <StyledText style={{ marginRight: 10 }} color={"white"}>
                  Mashup Now
                </StyledText>
              </Button>

              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium", marginTop: "55px" }}
              >{`Redemption Rules`}</StyledText>

              {note.map((note, index) => {
                return (
                  <NotesContainer key={index}>
                    <CircleContainer>
                      <Dot color={background} />
                    </CircleContainer>
                    <StyledText
                      size={13}
                      style={{ fontFamily: "MTNRegular", marginBlockStart: 0 }}
                    >
                      {note}
                    </StyledText>
                  </NotesContainer>
                );
              })}
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "32px",
                  marginBottom: "32px",
                  alignItems: "center",
                  marginInline: 15,
                }}
                color={background}
                onClick={() => history.push("/mashupnwin/mashup-drive")}
              >
                <StyledText style={{ marginRight: 10 }} color={"white"}>
                  Redirect to Mashup and Win
                </StyledText>
              </Button>
            </div>
          </Body>
          {/* <CurveOverImage
            style={{
              position: "relative",
              zIndex: 1,
              marginTop: -10,
              width: "100%",
            }}
            fill={"white"}
          /> */}
          <FooterImageContainer>
            <FooterImage src={tailImage} />
          </FooterImageContainer>
          {/* <CurveHolder style={{ position: "relative", zIndex: 1 }}>
            <Curve fill={background} />
          </CurveHolder> */}
          <FooterContainer activeTheme={background}>
            <StyledText size={24} color={"white"} style={{ marginTop: 0 }}>
              Here's some tips
            </StyledText>
            <TipsContainer>
              {tips.map((tip, index) => {
                const icons = [
                  <TimeIcon width={25} height={25} />,
                  <VoiceIcon width={25} height={25} fill={"black"} />,
                  <Phone width={25} height={25} />,
                ];
                return (
                  <TipContainer key={index}>
                    {icons[index]}
                    <Divider />
                    <StyledText
                      size={11}
                      color={"black"}
                      style={{ marginTop: "6px" }}
                    >
                      {tip}
                    </StyledText>
                  </TipContainer>
                );
              })}
            </TipsContainer>
            <Button
              style={{ margin: "35px 0" }}
              onClick={() => {
                history.push("/mashupnwin/faq");
              }}
              color={"white"}
            >
              <StyledText color={"black"}>
                {"Frequently asked questions"}
              </StyledText>
            </Button>
          </FooterContainer>
        </Children>
      </MainHolder>
    </>
  );
};

export default MashupnWinHome;
